<template>
	<div class="content" style="background-color: #FFF;">

		<div class="md-layout" style="padding-top: 00px;background-color: #FFF;" v-show="show">
			<div class="md-layout-item md-medium-size-100 md-size-100 text-center">
				<img src="@/assets/img/ats-header.png" style="width:50%">
			</div>
			<div class="md-layout-item md-medium-size-50 md-size-100 text-center" v-if="!error"
				style="margin: 0px 0 50px 0; text-align: center;display: flex;align-items: center;flex-direction: column;">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>ចំនួន</label>
						<md-input type="text" v-model="total"></md-input>
					</md-field>
				</div>
				<h3>សូមបង្ហាញ QR Code នៅទីនេះដើម្បីបើកសំបុត្រ</h3>
				<h4>(សូមបន្ថយកម្រឹតពន្លឺទូរស័ព្ទរបស់អ្នក)</h4>
				<qrcode-stream @decode="onDecode" @detect="onDetect" style="width:450px;height: 100%;"></qrcode-stream>
				<!-- <div style="width: 100%; height: 100%">

				</div> -->
			</div>
			<div v-if="error" style="text-align: center;width:100%;margin: 100px  0">
				<h1>មិនដំណើរការ</h1>
			</div>
			<div class="md-layout-item md-medium-size-100 md-size-100 text-center">
				<img src="@/assets/img/sponsor.png" style="width:50%">
				<!-- <img src="@/assets/img/sponsor1.png" style="width:20%"> -->
			</div>
		</div>

		<div class="md-layout" style="padding-top: 00px;background-color: #FFF;" v-show="!show">
			<div class="md-layout-item md-medium-size-100 md-size-100 text-center"
				style="width:100%;height:100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 180px">
				<h1>ជោគជ័យ</h1>
				<img src="@/assets/img/tick.png" style="width:180px">
				<h3>កំពុងបោះពុម្ភសំបុត្រ{{loading}}</h3>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				total: 1,
				show: true,
				success: false,
				loading: "",
				interval: null,
				error: false,
				update: 0,
				intervalCheck: null
			}
		},
		created() {
			this.check();
			// setTimeout(() => {
			// 	location.reload();
			// }, 600000)
		},
		beforeDestroy() {
			clearInterval(this.intervalCheck);
		},
		methods: {
			check() {

				this.intervalCheck = setInterval(() => {
					this.$http.get(this.config.api + "/public/connection").then(data => {
						this.$http.get(`https://localhost:8084/test`).then(data => {
							this.error = false;
						}).catch(err => {
							this.error = true;
						})
					}).catch(err => {
						this.error = true;
					})
				}, 10000)
			},
			load() {
				this.show = false;
				this.interval = setInterval(() => {
					if (this.loading.length > 2) {
						this.loading = "";
					} else {
						this.loading = this.loading + "."
					}
				}, 400)
				setTimeout(() => {
					this.show = true;
					this.success = false;
					clearInterval(this.interval);
				}, 4800)
			},
			onDetect(promise) {
				var self = this;
				promise.then(data => {
					// console.log(data);
				})
				// console.log("hi");
			},
			onDecode(qr) {
				// console.log(qr);
				if (String(qr).length == 12 || String(qr).length == 6) {
					this.load();
					this.$http.post(this.config.api + "/admin/ticket/check_in", {
						total: parseInt(this.total) || 1,
						ticket_id: qr
					}).then(data => {
						if (data.body.status == 'success') {
							let d = new Date();
							let checkin_id = encodeURIComponent(data.body.data.checkin_id);
							let name = encodeURIComponent(data.body.data.name);
							let ticket_id = encodeURIComponent("ATS24" + data.body.data.reference_code);
							let date = encodeURIComponent(this.config.datelify(d.getTime() / 1000))
							let time = encodeURIComponent(this.config.timemy(d.getTime() / 1000))
							let total = parseInt(this.total);

							this.$http.get(`https://localhost:8084/print?total=${total}&checkin_id=${checkin_id}&ticket_id=${ticket_id}&name=${name}&date=${date}&time=${time}`).then(data => {
								if (data.body == "OKAY") {
									// this.success = true;
									location.reload();
								}
							})

						}
					})
				}
			},
		}
	}
</script>
<style>
	body {
		background-color: #FFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/CheckIns.vue